import {
  QuoteCountStatusTypes,
  QuoteCountStatusActionTypes
} from './quoteCountStatusTypes';
import { QuoteCountStatusRequest } from '@/main/models/request/quoteRequest';
import { QuoteResponseCount } from '@/main/models/response';

export function getQuoteCountStatus(
  request: QuoteCountStatusRequest
): QuoteCountStatusActionTypes {
  return {
    type: QuoteCountStatusTypes.GET_QUOTE_COUNT_STATUS,
    payload: {
      request: request
    }
  };
}

export function saveQuoteCountStatus(
  data: QuoteResponseCount[] | null,
  isError: boolean,
  errorMessages: string[] | null
): QuoteCountStatusActionTypes {
  return {
    type: QuoteCountStatusTypes.SAVE_QUOTE_COUNT_STATUS,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerQuoteCountStatus(): QuoteCountStatusActionTypes {
  return {
    type: QuoteCountStatusTypes.RESET_REDUCER_QUOTE_COUNT_STATUS
  };
}

